/**
 * Generated by orval v8.15.0 🍺
 * Do not edit manually.
 * Сервис Интранет — API
 * API внутреннего корпоративного портала
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  unref
} from 'vue';
import type {
  MaybeRef
} from 'vue';

import type {
  CreateDocumentFolderDto,
  DocumentDownloadUrlDto,
  DocumentDto,
  DocumentFolderDto,
  DocumentsControllerCreateV1Body,
  UpdateDocumentDto,
  UpdateDocumentFolderDto
} from '../models';

import { apiRequest } from '../../client';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export interface foldersControllerListV1Response200 {
  data: DocumentFolderDto[]
  status: 200
}

export type foldersControllerListV1ResponseSuccess = (foldersControllerListV1Response200) & {
  headers: Headers;
};
;

export type foldersControllerListV1Response = (foldersControllerListV1ResponseSuccess)

export const getFoldersControllerListV1Url = () => {




  return `/api/v1/document-folders`
}

/**
 * @summary Папки библиотеки документов (плоский список)
 */
export const foldersControllerListV1 = async ( options?: RequestInit): Promise<foldersControllerListV1Response> => {

  return apiRequest<foldersControllerListV1Response>(getFoldersControllerListV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}




export const getFoldersControllerListV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof foldersControllerListV1>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof foldersControllerListV1>>, TError,void, TContext> => {

const mutationKey = ['foldersControllerListV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof foldersControllerListV1>>, void> = () => {


          return  foldersControllerListV1(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type FoldersControllerListV1MutationResult = NonNullable<Awaited<ReturnType<typeof foldersControllerListV1>>>

    export type FoldersControllerListV1MutationError = unknown

    /**
 * @summary Папки библиотеки документов (плоский список)
 */
export const useFoldersControllerListV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof foldersControllerListV1>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof foldersControllerListV1>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getFoldersControllerListV1MutationOptions(options), queryClient);
    }
    export interface foldersControllerCreateV1Response200 {
  data: DocumentFolderDto
  status: 200
}

export type foldersControllerCreateV1ResponseSuccess = (foldersControllerCreateV1Response200) & {
  headers: Headers;
};
;

export type foldersControllerCreateV1Response = (foldersControllerCreateV1ResponseSuccess)

export const getFoldersControllerCreateV1Url = () => {




  return `/api/v1/document-folders`
}

/**
 * @summary Создать папку (ADMIN или модератор documents)
 */
export const foldersControllerCreateV1 = async (createDocumentFolderDto: CreateDocumentFolderDto, options?: RequestInit): Promise<foldersControllerCreateV1Response> => {

  return apiRequest<foldersControllerCreateV1Response>(getFoldersControllerCreateV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createDocumentFolderDto)
  }
);}





export const getFoldersControllerCreateV1QueryKey = (createDocumentFolderDto?: MaybeRef<CreateDocumentFolderDto>,) => {
    return [
    'POST', 'api','v1','document-folders', createDocumentFolderDto
    ] as const;
    }


export const getFoldersControllerCreateV1QueryOptions = <TData = Awaited<ReturnType<typeof foldersControllerCreateV1>>, TError = unknown>(createDocumentFolderDto: MaybeRef<CreateDocumentFolderDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof foldersControllerCreateV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getFoldersControllerCreateV1QueryKey(createDocumentFolderDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof foldersControllerCreateV1>>> = ({ signal }) => foldersControllerCreateV1(unref(createDocumentFolderDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof foldersControllerCreateV1>>, TError, TData>
}

export type FoldersControllerCreateV1QueryResult = NonNullable<Awaited<ReturnType<typeof foldersControllerCreateV1>>>
export type FoldersControllerCreateV1QueryError = unknown


/**
 * @summary Создать папку (ADMIN или модератор documents)
 */

export function useFoldersControllerCreateV1<TData = Awaited<ReturnType<typeof foldersControllerCreateV1>>, TError = unknown>(
 createDocumentFolderDto: MaybeRef<CreateDocumentFolderDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof foldersControllerCreateV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFoldersControllerCreateV1QueryOptions(createDocumentFolderDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface foldersControllerUpdateV1Response200 {
  data: DocumentFolderDto
  status: 200
}

export type foldersControllerUpdateV1ResponseSuccess = (foldersControllerUpdateV1Response200) & {
  headers: Headers;
};
;

export type foldersControllerUpdateV1Response = (foldersControllerUpdateV1ResponseSuccess)

export const getFoldersControllerUpdateV1Url = (id: string,) => {




  return `/api/v1/document-folders/${id}`
}

/**
 * @summary Переименовать/переместить папку (ADMIN или модератор documents)
 */
export const foldersControllerUpdateV1 = async (id: string,
    updateDocumentFolderDto: UpdateDocumentFolderDto, options?: RequestInit): Promise<foldersControllerUpdateV1Response> => {

  return apiRequest<foldersControllerUpdateV1Response>(getFoldersControllerUpdateV1Url(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateDocumentFolderDto)
  }
);}





export const getFoldersControllerUpdateV1QueryKey = (id: MaybeRef<string>,
    updateDocumentFolderDto?: MaybeRef<UpdateDocumentFolderDto>,) => {
    return [
    'PATCH', 'api','v1','document-folders',id, updateDocumentFolderDto
    ] as const;
    }


export const getFoldersControllerUpdateV1QueryOptions = <TData = Awaited<ReturnType<typeof foldersControllerUpdateV1>>, TError = unknown>(id: MaybeRef<string>,
    updateDocumentFolderDto: MaybeRef<UpdateDocumentFolderDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof foldersControllerUpdateV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getFoldersControllerUpdateV1QueryKey(id,updateDocumentFolderDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof foldersControllerUpdateV1>>> = ({ signal }) => foldersControllerUpdateV1(unref(id),unref(updateDocumentFolderDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof foldersControllerUpdateV1>>, TError, TData>
}

export type FoldersControllerUpdateV1QueryResult = NonNullable<Awaited<ReturnType<typeof foldersControllerUpdateV1>>>
export type FoldersControllerUpdateV1QueryError = unknown


/**
 * @summary Переименовать/переместить папку (ADMIN или модератор documents)
 */

export function useFoldersControllerUpdateV1<TData = Awaited<ReturnType<typeof foldersControllerUpdateV1>>, TError = unknown>(
 id: MaybeRef<string>,
    updateDocumentFolderDto: MaybeRef<UpdateDocumentFolderDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof foldersControllerUpdateV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFoldersControllerUpdateV1QueryOptions(id,updateDocumentFolderDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface foldersControllerRemoveV1Response204 {
  data: void
  status: 204
}

export type foldersControllerRemoveV1ResponseSuccess = (foldersControllerRemoveV1Response204) & {
  headers: Headers;
};
;

export type foldersControllerRemoveV1Response = (foldersControllerRemoveV1ResponseSuccess)

export const getFoldersControllerRemoveV1Url = (id: string,) => {




  return `/api/v1/document-folders/${id}`
}

/**
 * @summary Удалить пустую папку (ADMIN или модератор documents)
 */
export const foldersControllerRemoveV1 = async (id: string, options?: RequestInit): Promise<foldersControllerRemoveV1Response> => {

  return apiRequest<foldersControllerRemoveV1Response>(getFoldersControllerRemoveV1Url(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getFoldersControllerRemoveV1QueryKey = (id: MaybeRef<string>,) => {
    return [
    'DELETE', 'api','v1','document-folders',id
    ] as const;
    }


export const getFoldersControllerRemoveV1QueryOptions = <TData = Awaited<ReturnType<typeof foldersControllerRemoveV1>>, TError = unknown>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof foldersControllerRemoveV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getFoldersControllerRemoveV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof foldersControllerRemoveV1>>> = ({ signal }) => foldersControllerRemoveV1(unref(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof foldersControllerRemoveV1>>, TError, TData>
}

export type FoldersControllerRemoveV1QueryResult = NonNullable<Awaited<ReturnType<typeof foldersControllerRemoveV1>>>
export type FoldersControllerRemoveV1QueryError = unknown


/**
 * @summary Удалить пустую папку (ADMIN или модератор documents)
 */

export function useFoldersControllerRemoveV1<TData = Awaited<ReturnType<typeof foldersControllerRemoveV1>>, TError = unknown>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof foldersControllerRemoveV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFoldersControllerRemoveV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface documentsControllerListV1Response200 {
  data: DocumentDto[]
  status: 200
}

export type documentsControllerListV1ResponseSuccess = (documentsControllerListV1Response200) & {
  headers: Headers;
};
;

export type documentsControllerListV1Response = (documentsControllerListV1ResponseSuccess)

export const getDocumentsControllerListV1Url = () => {




  return `/api/v1/documents`
}

/**
 * @summary Документы Агентства
 */
export const documentsControllerListV1 = async ( options?: RequestInit): Promise<documentsControllerListV1Response> => {

  return apiRequest<documentsControllerListV1Response>(getDocumentsControllerListV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}




export const getDocumentsControllerListV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof documentsControllerListV1>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof documentsControllerListV1>>, TError,void, TContext> => {

const mutationKey = ['documentsControllerListV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof documentsControllerListV1>>, void> = () => {


          return  documentsControllerListV1(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DocumentsControllerListV1MutationResult = NonNullable<Awaited<ReturnType<typeof documentsControllerListV1>>>

    export type DocumentsControllerListV1MutationError = unknown

    /**
 * @summary Документы Агентства
 */
export const useDocumentsControllerListV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof documentsControllerListV1>>, TError,void, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof documentsControllerListV1>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDocumentsControllerListV1MutationOptions(options), queryClient);
    }
    export interface documentsControllerCreateV1Response200 {
  data: DocumentDto
  status: 200
}

export type documentsControllerCreateV1ResponseSuccess = (documentsControllerCreateV1Response200) & {
  headers: Headers;
};
;

export type documentsControllerCreateV1Response = (documentsControllerCreateV1ResponseSuccess)

export const getDocumentsControllerCreateV1Url = () => {




  return `/api/v1/documents`
}

/**
 * @summary Загрузить документ (ADMIN или модератор documents)
 */
export const documentsControllerCreateV1 = async (documentsControllerCreateV1Body: DocumentsControllerCreateV1Body, options?: RequestInit): Promise<documentsControllerCreateV1Response> => {
    const formData = new FormData();
formData.append(`file`, documentsControllerCreateV1Body.file);
formData.append(`title`, documentsControllerCreateV1Body.title);
if(documentsControllerCreateV1Body.description !== undefined) {
 formData.append(`description`, documentsControllerCreateV1Body.description);
 }
if(documentsControllerCreateV1Body.category !== undefined) {
 formData.append(`category`, documentsControllerCreateV1Body.category);
 }
if(documentsControllerCreateV1Body.folderId !== undefined) {
 formData.append(`folderId`, documentsControllerCreateV1Body.folderId);
 }

  return apiRequest<documentsControllerCreateV1Response>(getDocumentsControllerCreateV1Url(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getDocumentsControllerCreateV1QueryKey = (documentsControllerCreateV1Body?: MaybeRef<DocumentsControllerCreateV1Body>,) => {
    return [
    'POST', 'api','v1','documents', documentsControllerCreateV1Body
    ] as const;
    }


export const getDocumentsControllerCreateV1QueryOptions = <TData = Awaited<ReturnType<typeof documentsControllerCreateV1>>, TError = unknown>(documentsControllerCreateV1Body: MaybeRef<DocumentsControllerCreateV1Body>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsControllerCreateV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getDocumentsControllerCreateV1QueryKey(documentsControllerCreateV1Body);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof documentsControllerCreateV1>>> = ({ signal }) => documentsControllerCreateV1(unref(documentsControllerCreateV1Body), { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof documentsControllerCreateV1>>, TError, TData>
}

export type DocumentsControllerCreateV1QueryResult = NonNullable<Awaited<ReturnType<typeof documentsControllerCreateV1>>>
export type DocumentsControllerCreateV1QueryError = unknown


/**
 * @summary Загрузить документ (ADMIN или модератор documents)
 */

export function useDocumentsControllerCreateV1<TData = Awaited<ReturnType<typeof documentsControllerCreateV1>>, TError = unknown>(
 documentsControllerCreateV1Body: MaybeRef<DocumentsControllerCreateV1Body>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsControllerCreateV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDocumentsControllerCreateV1QueryOptions(documentsControllerCreateV1Body,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface documentsControllerGetDownloadUrlV1Response200 {
  data: DocumentDownloadUrlDto
  status: 200
}

export type documentsControllerGetDownloadUrlV1ResponseSuccess = (documentsControllerGetDownloadUrlV1Response200) & {
  headers: Headers;
};
;

export type documentsControllerGetDownloadUrlV1Response = (documentsControllerGetDownloadUrlV1ResponseSuccess)

export const getDocumentsControllerGetDownloadUrlV1Url = (id: string,) => {




  return `/api/v1/documents/${id}/download-url`
}

/**
 * @summary Presigned-ссылка на скачивание документа
 */
export const documentsControllerGetDownloadUrlV1 = async (id: string, options?: RequestInit): Promise<documentsControllerGetDownloadUrlV1Response> => {

  return apiRequest<documentsControllerGetDownloadUrlV1Response>(getDocumentsControllerGetDownloadUrlV1Url(id),
  {
    ...options,
    method: 'GET'


  }
);}




export const getDocumentsControllerGetDownloadUrlV1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof documentsControllerGetDownloadUrlV1>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof documentsControllerGetDownloadUrlV1>>, TError,{id: string}, TContext> => {

const mutationKey = ['documentsControllerGetDownloadUrlV1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof documentsControllerGetDownloadUrlV1>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  documentsControllerGetDownloadUrlV1(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DocumentsControllerGetDownloadUrlV1MutationResult = NonNullable<Awaited<ReturnType<typeof documentsControllerGetDownloadUrlV1>>>

    export type DocumentsControllerGetDownloadUrlV1MutationError = unknown

    /**
 * @summary Presigned-ссылка на скачивание документа
 */
export const useDocumentsControllerGetDownloadUrlV1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof documentsControllerGetDownloadUrlV1>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof documentsControllerGetDownloadUrlV1>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDocumentsControllerGetDownloadUrlV1MutationOptions(options), queryClient);
    }
    export interface documentsControllerUpdateV1Response200 {
  data: DocumentDto
  status: 200
}

export type documentsControllerUpdateV1ResponseSuccess = (documentsControllerUpdateV1Response200) & {
  headers: Headers;
};
;

export type documentsControllerUpdateV1Response = (documentsControllerUpdateV1ResponseSuccess)

export const getDocumentsControllerUpdateV1Url = (id: string,) => {




  return `/api/v1/documents/${id}`
}

/**
 * @summary Изменить документ (ADMIN или модератор documents)
 */
export const documentsControllerUpdateV1 = async (id: string,
    updateDocumentDto: UpdateDocumentDto, options?: RequestInit): Promise<documentsControllerUpdateV1Response> => {

  return apiRequest<documentsControllerUpdateV1Response>(getDocumentsControllerUpdateV1Url(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateDocumentDto)
  }
);}





export const getDocumentsControllerUpdateV1QueryKey = (id: MaybeRef<string>,
    updateDocumentDto?: MaybeRef<UpdateDocumentDto>,) => {
    return [
    'PATCH', 'api','v1','documents',id, updateDocumentDto
    ] as const;
    }


export const getDocumentsControllerUpdateV1QueryOptions = <TData = Awaited<ReturnType<typeof documentsControllerUpdateV1>>, TError = unknown>(id: MaybeRef<string>,
    updateDocumentDto: MaybeRef<UpdateDocumentDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsControllerUpdateV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getDocumentsControllerUpdateV1QueryKey(id,updateDocumentDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof documentsControllerUpdateV1>>> = ({ signal }) => documentsControllerUpdateV1(unref(id),unref(updateDocumentDto), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof documentsControllerUpdateV1>>, TError, TData>
}

export type DocumentsControllerUpdateV1QueryResult = NonNullable<Awaited<ReturnType<typeof documentsControllerUpdateV1>>>
export type DocumentsControllerUpdateV1QueryError = unknown


/**
 * @summary Изменить документ (ADMIN или модератор documents)
 */

export function useDocumentsControllerUpdateV1<TData = Awaited<ReturnType<typeof documentsControllerUpdateV1>>, TError = unknown>(
 id: MaybeRef<string>,
    updateDocumentDto: MaybeRef<UpdateDocumentDto>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsControllerUpdateV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDocumentsControllerUpdateV1QueryOptions(id,updateDocumentDto,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






export interface documentsControllerRemoveV1Response204 {
  data: void
  status: 204
}

export type documentsControllerRemoveV1ResponseSuccess = (documentsControllerRemoveV1Response204) & {
  headers: Headers;
};
;

export type documentsControllerRemoveV1Response = (documentsControllerRemoveV1ResponseSuccess)

export const getDocumentsControllerRemoveV1Url = (id: string,) => {




  return `/api/v1/documents/${id}`
}

/**
 * @summary Удалить документ (ADMIN или модератор documents)
 */
export const documentsControllerRemoveV1 = async (id: string, options?: RequestInit): Promise<documentsControllerRemoveV1Response> => {

  return apiRequest<documentsControllerRemoveV1Response>(getDocumentsControllerRemoveV1Url(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDocumentsControllerRemoveV1QueryKey = (id: MaybeRef<string>,) => {
    return [
    'DELETE', 'api','v1','documents',id
    ] as const;
    }


export const getDocumentsControllerRemoveV1QueryOptions = <TData = Awaited<ReturnType<typeof documentsControllerRemoveV1>>, TError = unknown>(id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsControllerRemoveV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getDocumentsControllerRemoveV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof documentsControllerRemoveV1>>> = ({ signal }) => documentsControllerRemoveV1(unref(id), { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: computed(() => unref(id) !== null && unref(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof documentsControllerRemoveV1>>, TError, TData>
}

export type DocumentsControllerRemoveV1QueryResult = NonNullable<Awaited<ReturnType<typeof documentsControllerRemoveV1>>>
export type DocumentsControllerRemoveV1QueryError = unknown


/**
 * @summary Удалить документ (ADMIN или модератор documents)
 */

export function useDocumentsControllerRemoveV1<TData = Awaited<ReturnType<typeof documentsControllerRemoveV1>>, TError = unknown>(
 id: MaybeRef<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof documentsControllerRemoveV1>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getDocumentsControllerRemoveV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






